export default __webpack_public_path__ + "static/intro-c7f1c7bf890bbbaf5672ee079be0f96e.jpg";